import AppConstants from '../config/app.constants';

let MobileAppService = function ($http, $q) {

    let saveApp = (data) => {
        return $http
            .post(AppConstants.api + `/mobile-app/save-app`, data)
            .then((res) => {
                return res.data;
            })
    }

    let getAll = function () {
        return $http
            .get(AppConstants.api + `/mobile-app/get-app`)
            .then((res) => {
                return res.data
            })
    }

    return {
        saveApp,
        getAll
    };
}

MobileAppService.$inject = ['$http', '$q'];

export default MobileAppService;


// WEBPACK FOOTER //
// ./client/app/services/mobile-app.service.js